import { Icon } from './icon'
import { resolveIdentityPrefixForPath } from './utils'

class StaticElements {
  get removeCircleOutlineIcon() {
    return new Icon('icon-remove-circle-outline', { title: 'Remove' }).asString()
  }

  get submissionsIcon() {
    return new Icon('icon-submissions', { classes: 'box-content p-2 text-2xl text-whitelabel-400' }).asString()
  }

  submissionMarkup(option) {
    if (option.viewable) {
      return `
        <div class="flex justify-between">
          <div class="w-[94%] related-submission" id="related-submission-${option.id}">
            <turbo-frame id="related_frame_compliance_submission_${option.container_id}">
              <a
                id="${option.id}"
                href="${resolveIdentityPrefixForPath(`/i/000/submission_containers/${option.container_id}`)}"
                data-turbo-stream
                class="
                  submission-selection-container flex items-center justify-between mt-2 p-2
                  removal-container type-body-2 border-t-1 border-r-1 border-l-1 border-gray-200
                  hover:bg-gray-50 rounded-t rounded-b border-b-1
                "
              >
                <span id="${option.id}-viewable" class="sr-only">${option.viewable}</span>
                <span id="${option.id}-container-id" class="sr-only">${option.container_id}</span>
                <span id="${option.id}-submission-id" class="sr-only">${option.submission_id}</span>
                <div class="flex">
                  <div class="bg-white rounded-full submission-svg-background">
                    ${this.submissionsIcon}
                  </div>
                  <div class="ml-2">
                    <div>
                      <span id="${option.id}-description">${option.description}</span> by <span id="${option.id}-user-name" class="text-xs text-gray-400 italic">${option.user_name || option.userName}</span>
                    </div>
                    <div>
                      <p class="text-xs">Submitted <b class="text-whitelabel-400"><span id="${option.id}-created-at">${option.created_at}</span></b> in <b id="${option.id}-category" class="text-whitelabel-400">${option.category}</b></p>
                    </div>
                  </div>
                </div>
              </a>
            </turbo-frame>
          </div>
          <div
            class="text-gray-300 hover:text-gray-400 cursor-pointer flex mt-2 removal-container w-10 border-t-1 border-r-1 border-l-1 border-gray-200 hover:bg-gray-50 border-b-1 items-center rounded"
            x-on:click="
              new window.app.generateField().removeSubmission($event)
            "
          >
            <div class="flex justify-center text-xl w-full" name=${option.id}>
              ${this.removeCircleOutlineIcon}
            </div>
          </div>
        </div>
      `
    } else {
      return `
        <div
          class="related-submission flex items-center justify-between mt-2 p-2 removal-container type-body-2 border-t-1 border-r-1 border-l-1 border-gray-200 hover:bg-gray-50 rounded-t rounded-b border-b-1"
          id="related-submission-${option.id}"
        >
          <div class="flex">
            <div class="bg-white rounded-full submission-svg-background">
              ${this.submissionsIcon}
            </div>
            <div class="ml-2">
              <div>
                <i>You are not authorized to view this submission</i> by <span id="${option.id}-user-name" class="text-xs text-gray-400 italic">${option.user_name || option.userName}</span>
              </div>
              <div>
                <p class="text-xs">Submitted <b class="text-whitelabel-400"><span id="${option.id}-created-at">${option.created_at}</span></b> in <b id="${option.id}-category" class="text-whitelabel-400">${option.category}</b></p>
              </div>
            </div>
          </div>
        </div>
      `
    }
  }

  toUrl(option) {
    return option.form_type + 's'
  }
}

export default StaticElements
